import * as SX from './sx';
import * as Styled from './styles';

import { classnames, fDate } from '@aibees/shared/utils';

import { Chip } from '@aibees/shared/components';
import type { UpcomingPlanBadgeProps as Props } from './types';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { usePlanCardContext } from '../../context';

export const UpcomingPlanBadge = memo(({ className }: Props) => {
  const { data } = useCurrentSubscriptionApi();
  const { selectedPlan, isCompact } = usePlanCardContext();

  const nextPlan = data?.next;

  if (!nextPlan || selectedPlan?.id !== nextPlan?.plan?.id) return null;

  const interval = nextPlan.plan?.interval === 'MONTH' ? 'month' : 'year';

  return (
    <Styled.Wrapper
      className={classnames('UpcomingPlanBadge', className)}
      sx={SX.root}
      // The compare-table (compact) column is too narrow to keep the chip and
      // the full effective-date line on one row without truncating, so stack
      // them there and let the text wrap.
      direction={'row'}
      justifyContent={isCompact ? 'flex-start' : 'space-between'}
      alignItems="center"
      flexWrap="nowrap"
      gap={isCompact ? 0.5 : 1}
    >
      <Chip label="Upcoming" color="warning" variant="filled" size="small" />
      <Typography
        variant="body5"
        color="warning.700"
        fontWeight={500}
        noWrap={!isCompact}
      >
        Effective on {fDate(nextPlan?.startDate)} ·{' '}
        {nextPlan?.plan?.metadata.request}/{interval}
      </Typography>
    </Styled.Wrapper>
  );
});

UpcomingPlanBadge.displayName = 'UpcomingPlanBadge';
